import api from '@/apis/ba/baDepositAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('bADeposit', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ba_deposit',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Xóa nhiều
   */
  async customDelete(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      res = await api.customDelete(payload);
      // Lọc các dữ liệu đã xóa được nên không cần refresh ds nữa
      let errValidate = ['VALIDATE', 'Business', 'Exception', 'GENERATE_DATA'];
      let keyField = context.state._config.field.key;
      //Danh sách gửi lên xóa
      let deleted = [...payload.Models];
      if (keyField && res) {
        for (let i = 0; i < res.length; i++) {
          // Nếu không xóa được thì loại bỏ khỏi list xóa
          if (errValidate.find(x => x === res[i]?.Code)) {
            if (res[i] && res[i].Data && res[i].Data.Data) {
              let itemError = payload.Models[res[i].Index];
              //Loại đi những bản ghi không xóa được
              deleted = deleted.filter((item, index) => {
                return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
              });
            }
          }
        }
      }
      //Commit thực hiện xóa
      context.commit('deleteItems', deleted);
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },

  /**
   * Cập nhật bản ghi mới ra màn danh sách sau khi sinh
   * NTLOC 26.10.2022
   */
  async insertVoucherEmis(context, payload) {
    context.commit('insertListItem', payload);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
